<form class="search-container" [formGroup]="detailForm">

  <div class="input-part">
    @if (eInput.value.length > 0 && focusout == true && click == true && !requestInProce) {
      <span>
        <a class="icon-remove" href="javascript:void(0);" (click)="removeSearchVal()">
          <i class="far fa-times-circle dropdown-icon"></i>
        </a>
      </span>
    }
    @if (eInput.value.length < 3 && focusout == false && click == true) {
      <span >
        <a class="icon-remove" href="javascript:void(0);" (click)="removeSearchVal()">
          <span class="span-dropdown">{{eInput.value.length}}/3</span>
        </a>
      </span>
    }
    <input [disabled]="requestInProce" id="{{inputId}}" type="text" placeholder="{{'search.search' | translate}}" #eInput formControlName="searchVal" (keyup.enter)="onSubmit()" class="input-search-clicked" (focusout)="onFocusOut()" (focus)="onFocusIn()" >
  </div>

  <div class="btn-valid">
    <app-btn-action [typdeBtnAction]="btnActionEnum.SEARCH" [activeBtnSearch]="active" (btnClickEventEmitter)="btnEventReceiver($event)" [btnDisabled]="btnDisable"></app-btn-action>
  </div>
</form>
